const BasketInfo = ({ itemsCount }) => {
  return <>{itemsCount}</>;
};

export default BasketInfo;
